import { useTranslation } from "react-i18next";
import {
  InfoWrapper,
  InfoTitleWrapper,
  InfoDescWrapper,
  ContactsWrapper,
  ContactWrapper,
  Email,
  Vat,
  IconsWrapper,
} from "../styles";
import EmailIcon from "@mui/icons-material/Email";
import PlaceIcon from "@mui/icons-material/Place";
import instaLogo from "../../../assets/icons/instagram-icon.png";
import fbLogo from "../../../assets/icons/facebook-icon.png";
import linkedInLogo from "../../../assets/icons/linkedin_icon.png";
import ytLogo from "../../../assets/icons/youtube_icon.png";

export default function ContactUsInfos() {
  const { t } = useTranslation();
  return (
    <InfoWrapper>
      <div>
        <InfoTitleWrapper>{t("contact_us.get_in_touch")}</InfoTitleWrapper>
        <InfoDescWrapper>{t("contact_us.description")}</InfoDescWrapper>
      </div>
      <ContactsWrapper>
        <div>
          <ContactWrapper>
            <EmailIcon sx={{ color: "#72C2CC" }} />
            <Email
              onClick={(e) => {
                window.location.href = "mailto:info@my1job.be";
                e.preventDefault();
              }}
            >
              info@my1job.be
            </Email>
          </ContactWrapper>
          <ContactWrapper>
            <div
              style={{
                color: "#72C2CC",
                fontFamily: "Montserrat",
                fontWeight: 500,
                width: "250px",
              }}
              className="w-full border-2"
            >
              {t("misc.powered_by")} Talent Bridgers
            </div>
          </ContactWrapper>
          <ContactWrapper>
            <PlaceIcon sx={{ color: "#72C2CC" }} />
            <Email
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place/Generaal+Lemanstraat+36,+1600+Sint-Pieters-Leeuw,+Belgium/@50.7919077,4.2806228,551m/data=!3m2!1e3!4b1!4m6!3m5!1s0x47c3c66c3f50335d:0xde266833f64e140c!8m2!3d50.7919077!4d4.2831977!16s%2Fg%2F11c5qkx1nv?entry=ttu&g_ep=EgoyMDI1MDMzMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                  "_blank"
                )
              }
            >
              Ancien Dieweg 16, 1180 Uccle
            </Email>
          </ContactWrapper>
          <ContactWrapper>
            <p style={{ color: "#72C2CC", fontFamily: "Montserrat" }}>VAT</p>
            <Vat>BE 1021.290.432</Vat>
          </ContactWrapper>
        </div>
        <IconsWrapper>
          <img
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() =>
              window.open("https://www.instagram.com/myfirstjob01/", "_blank")
            }
            src={instaLogo}
          />
          <img
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() =>
              window.open("https://www.facebook.com/my1job.be", "_blank")
            }
            src={fbLogo}
          />
          <img
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() =>
              window.open(
                "https://www.linkedin.com/company/89610471/admin/",
                "_blank"
              )
            }
            src={linkedInLogo}
          />
          <img
            style={{ cursor: "pointer" }}
            onClick={() =>
              window.open(
                "https://www.youtube.com/channel/UCXQw5DktyC03RsGBKEHt0_w",
                "_blank"
              )
            }
            src={ytLogo}
          />
        </IconsWrapper>
      </ContactsWrapper>
    </InfoWrapper>
  );
}
